import { getCookie } from 'cookies-next';

const baseUrl = process.env.NEXT_PUBLIC_BASE_URL

export const getPropertyCardInfo = async (id) => {
    let currencyValue = getCookie('currency')
    let localeValue = getCookie('NEXT_LOCALE')

    // console.log(currencyValue)

    const url = `${baseUrl}/properties/map/${id}`
    const headers = {
        'apikey': process.env.NEXT_PUBLIC_RSTBASE_API_KEY,
        'currency': currencyValue || 'thb',
        'locale': localeValue || 'en'
    }

    const response = await fetch(url, {
        headers: headers,
        // cache: 'no-store',
        next: { revalidate: 1800 } // 30m
    })

    const result = await response.json()

    // console.log(result)

    return result
}